module.exports = "/images/key2.svg?ff71ca1b7be6348aeb1dc02891b114ce";